module.exports = __webpack_public_path__ + "static/media/product1.aa3e9e6a.jpg";